import { render, staticRenderFns } from "./Covid12Component.vue?vue&type=template&id=c4931966"
import script from "./Covid12Component.vue?vue&type=script&lang=js"
export * from "./Covid12Component.vue?vue&type=script&lang=js"
import style0 from "./Covid12Component.vue?vue&type=style&index=0&id=c4931966&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports